import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { ModalService, ModalType } from '../../services/modal.service';
import * as fromProcess from '../../store/process/process.selectors';
import { Subject, map, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppType } from '../../model/app-type.model';
import { Boundries } from 'src/app/model/boundries.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { TrackingService } from '../../tracking/tracking.service';

@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.scss'],
})
export class FabComponent implements OnDestroy, AfterViewInit {
  @Output() emitComponentLoaded = new EventEmitter<ElementRef<HTMLElement>>();
  @Input() buttonsOverlap = false;
  @Input() fabButtonBottomPosition: number | null = null;
  @ViewChild('fabButton', { static: false }) private fabButton!: ElementRef<HTMLElement>;

  currentStep$ = this.store.select(fromProcess.selectProcessStep);
  visible$ = this.store
    .select(fromProcess.selectProcessHelpModalVisible)
    .pipe(map((visible) => visible && environment.app === AppType.Direct));

  ngDestroy$ = new Subject<void>();

  isExtendedOpen = false;
  navButtonBoundries: Boundries | null = null;

  constructor(
    private store: Store<AppState>,
    private modalService: ModalService,
    private trackingService: TrackingService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  openExtended() {
    this.isExtendedOpen = true;
    this.trackingService.fabOpen();
  }

  closeExtended() {
    this.isExtendedOpen = false;
    this.updateButtonRef();
  }

  openContact() {
    this.modalService.openModal(ModalType.ContactAgent);
    this.closeExtended();
  }

  updateButtonRef() {
    this.changeDetectorRef.detectChanges();
    this.emitComponentLoaded.emit(this.fabButton);
  }

  ngAfterViewInit(): void {
    this.updateButtonRef();

    this.visible$.pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.updateButtonRef();
    });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
